import Separator from '@/core/components/Separator/Separator';

export default Separator;
